<!-- eslint-disable -->
<template lang="pug">
    .battle-box(:class="{'battle-box_archived': olympiad.status === 'archived'}")
        .battle-box__content
            .battle-box__item
                img.battle-box__image(
                    :src="olympiad.logo",
                )
            .battle-box__item(v-if="olympiad.status !== 'archived'")
                | {{ formattedDate }}
                template(v-if="time")
                    | {{ time }}
            .battle-box__item.battle-box__title(
                v-text="olympiad.title",
            )
            .battle-box__item.battle-box__name(
                v-text="olympiad.name"
            )
            template(v-if="olympiad.status !== 'archived'")
                .battle-box__item.battle-box__item_light
                    div.olympiad-preview__registration
                        span(v-text="registrationStatus")
                    div.olympiad-preview__registration(
                        v-if="user.type === 'student' || user.type === 'olympiads-student'"
                    )
                        template(v-if="olympiad.authUserRegisteredLevel")
                            span(v-if="olympiad.authUserRegisteredLevel.authCompletedUser.length")
                                | {{ $i18n.t('olympiads.olympiads_preview_allTasksCompleted') }}
                            span(v-else) {{ $i18n.t('olympiads.olympiads_preview_applicationIsAccepted') }}
                        template(v-else-if="olympiad.isRegistrationEnded")
                            span {{ $i18n.t('olympiads.olympiads_preview_registrationEnded') }}
                .battle-box__item
                    cs-button(
                        color="blue"
                        pattern="primary-outline"
                        html-tag="a"
                        :href="olympiad.rulesLink"
                        target="_blank"
                        narrow
                    )
                        | {{ $i18n.t('olympiads.olympiads_preview_theRulesOfTheOlympiad') }}
                    cs-button(
                        :style="{marginLeft: '10px'}"
                        color="blue"
                        pattern="primary-outline"
                        narrow
                    )
                        | {{ $i18n.t('auth.auth_login_button') }}
</template>

<script>
    /*eslint-disable*/
    import moment from "moment-timezone";
    import {mapState} from 'vuex';

    const timezone = 'Europe/Moscow';

    export default {
        props: {
            olympiad: Object,
        },
        created() {
            moment.locale(this.$i18n.locale);
        },
        computed: {
            registrationStatus() {
                if (this.olympiad.status !== 'archived') {
                    let currentTime = moment.tz(timezone);
                    if (this.isRegistrationAllowed) {
                        return this.$i18n.t('olympiads.olympiads_preview_registerWillEnd')
                                + moment(this.olympiad.registrationEnd).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.olympiad.registrationEnd).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                    } else if (currentTime.isBefore(moment.tz(this.olympiad.registrationStart, timezone))) {
                        return this.$i18n.t('olympiads.olympiads_preview_registerWillBegin')
                                + moment(this.olympiad.registrationStart).format('DD MMM YYYY')
                                + this.$i18n.t('olympiads.olympiads_preview_in')
                                + moment(this.olympiad.registrationStart).format('HH:mm')
                                + this.$i18n.t('olympiads.olympiads_preview_timezone');
                    }
                }
                return this.$i18n.t('olympiads.olympiads_preview_registerIsClosed');
            },
            isRegistrationAllowed() {
                return moment.tz(timezone).isBetween(
                        moment.tz(this.olympiad.registrationStart, timezone),
                        moment.tz(this.olympiad.registrationEnd, timezone)
                );
            },
            formattedDate() {
                return moment(this.olympiad.date).format('DD MMM YYYY')
            },
            time() {
                if (this.user.type === 'student' || this.user.type === 'olympiads-student') {
                    let level = this.olympiad.levels.find(level => {
                        if (level.authRegisteredUser.length) {
                            level.endTime = level.endTime || level.stages[level.stages.length - 1].endTime;
                        }
                        return level.authRegisteredUser.length;
                    });
                    return level ? ' ' + level.startTime + '-' + level.endTime : null;
                }
                return null;
            },
            ...mapState({
                user: state => state.auth.user
            })
        }
    }
</script>

<style scoped lang="scss">
    .battle-box {
        cursor: pointer;
        box-sizing: border-box;
        height: 100%;
        border-radius: 20px;
        margin-bottom: 20px;
        background: url("../../assets/images/battles/battle-background.png") $hsl-color-green-58;
        text-align: center;
        padding: 30px;
        @include media($xlg) {
            padding: 55px;
        }
    }

    .battle-box_archived {
        background-color: $hsl-color-blue-56;
    }

    .battle-box__content {
        background: #FFFFFF;
        border-radius: 20px;
        padding: 45px 10px;
        @include media($sm) {
            padding: 45px 25px;
        }
    }

    .battle-box__item {
        display: flex;
        justify-content: center;
        margin: 20px 0;
    }

    .battle-box__item:first-child {
        margin-top: 0;
    }

    .battle-box__item:last-child {
        margin-bottom: 0;
    }

    .battle-box__item_light {
        color: #858585;
        display: block;
    }

    .battle-box__image {
        border-radius: $border-radius-circle;
        max-width: 100px;
    }

    .battle-box__name {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .buttons {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
</style>
